import { Injectable } from '@angular/core';

/**
 * A placeholder for a service that supplies the page parameters that are
 * used by soy in the server.
 */
@Injectable({
  providedIn: 'root'
})
export class PageParametersService {

  pageName: string;
  servicelyVersion: string;
  modeName: string;
  noMenuMode: string;

  constructor() { }
}
